import { matchPath as _matchPath } from 'react-router';
import matchQuery from '@src/components/route/route-switch-enhance/match-query';

/**
 * 匹配路径
 * @param {string} pathname - 相对路径, e.g. /person/detail
 * @param {string} query - query string, e.g. ?id=1
 * @param {object} options - 配置参数, options.path 为路径
 * @returns {*}
 */
export default function matchPath({ pathname, query }, options) {
  const isMathPath = _matchPath(pathname, options);
  const isMathQuery = matchQuery(query, options.query, options);

  if (isMathPath && isMathQuery) {
    return {
      ...isMathPath,
      ...isMathQuery
    };
  } else {
    return null;
  }
}
